import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Sdk() {
  const { i18n } = useTranslation();

  useEffect(() => {
    const syncLang = () => {
      const lang = i18n.language;
      const docsLang = lang === 'en-US' ? 'en' : 'zh';
      localStorage.setItem('kimap-docs-lang', docsLang);
      const iframe = document.querySelector('iframe');
      if (iframe?.contentWindow) {
        iframe.contentWindow.postMessage({ type: 'kimap-set-lang', lang: docsLang }, '*');
      }
    };

    syncLang();

    i18n.on('languageChanged', syncLang);
    return () => {
      i18n.off('languageChanged', syncLang);
    };
  }, [i18n]);

  return (
    <div style={{ height: 'calc(100vh - 64px)', margin: '-16px' }}>
      <iframe
        src="/sdk/1-安装与快速开始.html"
        title="Kimap SDK Docs"
        style={{ width: '100%', height: '100%', border: 'none' }}
      />
    </div>
  );
}
